<template>
    <mu-content-block style="padding: 0;">
        <mu-flexbox class="img-flex-box" justify="flex-start">
            <!--已上传图片展示-->
            <mu-flexbox-item v-for="(item,index) in imgArr" :key="'flexbox-item' + index" class="img-flex-item" grow="0">
                <img :src="item" alt="" class="upload-img" ref="imageArr">
                <icon value="delete" :size="30" class="img-delect" @click.native="deleteImg(index)" color="#488bf4"></icon>
            </mu-flexbox-item>
            <!--上传图片按钮-->
            <!--v-show="imgArr.length < 3"-->
            <mu-flexbox-item class="img-flex-item-add" grow="0" v-show="imgArr.length <= 0">
                <input type="file"  accept="image/png, image/jpeg, image/gif, image/jpg, image/bmp"
                       class="imgfile-input" id="upImg" @change="handleFileChange"
                       :key="inputTmpKey"
                       ref="imgInput">
                <label for="upImg">
                    <icon value="add" color="#488bf4" :size="35" click="upImg.click()"i></icon>
                </label>
            </mu-flexbox-item>
        </mu-flexbox>
    </mu-content-block>
</template>

<script>
    export default {
        name: "imageReader",
        data: () => {
            return {
                imgArr:[],
                inputTmpKey: Date.now(),
            }
        },
        props:{
            selectImg:{
                type: Function,
                default: () => {}
            }
        },
        methods:{
            replayformeClick() {
            },
            $_cleaeFile() {
                this.inputTmpKey = Date.now()
            },
            // 选取图片
            async handleFileChange(e) {
              // this.$reportLog('card_problem_add_image', 'btn', '添加图片');
              // let $this = this;
              let inputDOM = e.target;
              // let file = inputDOM.files[0];
              // console.log(inputDOM.files)
              this.showImg(inputDOM.files[0]);
              this.selectImg(inputDOM.files[0]);
              // this.upLoadImg();
            },
            // 展示图片
            async showImg(file) {
              let $this = this;
              let reader = new window.FileReader();
               reader.readAsDataURL(file);
              reader.onloadend = async (e) => {
                  console.log(e.target.result)
                  $this.imgArr.push(e.target.result);
                  $this.$_cleaeFile()
              };
            },
            deleteImg(index){
                this.imgArr.splice(index, 1);
                // 临时这样写 后面会做些基础组件的时候修改
                this.selectImg(null);
            }
        }
    }
</script>

<style scoped>
    .upload-img {
        height: 8rem;
        width: 8rem;
    }

    .img-delect {
        position: absolute;
        top: 0;
        right: 0;
    }
    .img-flex-item {
        padding: 2rem 0.5rem;
        position: relative;
        width: 10rem;
    }
    .img-flex-item-add {
        padding: 2.2rem 0.5rem;
        width: 10rem;
        background: #F2F6F8;
        border: 1px solid #C6CAD5;
        position: relative;
        label {
            height: 8rem;
            width: 8rem;
            display: block;
            background: #f3f3f3;
            line-height: 8rem;
        }
    }
.imgfile-input{
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    opacity: 0;
}
</style>